interface CacheParams {
  key: string; // 缓存名称
  fn: any; // 缓存函数
  params?: any; // 函数参数
  expire?: number; // 缓存间隔，默认1min
}
const checkFunction = (fn: any) => {
  return typeof fn === 'function';
};
export const setCache = async (cacheParams: CacheParams) => {
  if (typeof cacheParams.key !== 'string' || !cacheParams.key) {
    throw new Error('key must string');
  }
  if (!checkFunction(cacheParams.fn)) {
    throw new Error('fn is invalid');
  }
  let cache: any = JSON.parse(
    localStorage.getItem(`__auto__${cacheParams.key}__`) || '{}',
  );
  const current = Date.now();
  if (
    !cache ||
    !Object.keys(cache).length ||
    !cache.value ||
    current >= cache.expire
  ) {
    try {
      const value = await cacheParams.fn(cacheParams.params);
      cache = {
        value,
        expire: current + (cacheParams.expire || 1) * 1000 * 60,
      };
      console.log('refresh cache==>' + cacheParams.key, value);
      localStorage.setItem(
        `__auto__${cacheParams.key}__`,
        JSON.stringify(cache),
      );
    } catch (error) {
      console.log(error);

      // throw new Error(error);
    }
  }
  // console.log('get cache==>', cache.value);
  return cache.value;
};
